import axios from "axios";
import React, { useState, useEffect, useMemo } from "react"

function HeaderMobileMenu(props) {

    function closeMenuBar() {
        document.getElementsByClassName('mobile_menu_module')[0].style.display = "none";

    }
    function elementor_menu() {

        return (
            <span className="content" dangerouslySetInnerHTML={{ __html: window.elementor_menu }}></span>
        );
    }
    return (<section class="module_section mobile_menu_module">

        <div class="module">
            <div class="module_close">
                <img src="/wp-content/uploads/2022/09/cancel.png" onClick={closeMenuBar} />
            </div>
            <div class="login-section">
                <div class="sec-on">
               
                    <h4>Users</h4>
                    {/* {elementor_menu()} */}
                    {/* <span><a href="" dangerouslySetInnerHTML={{__html: window.elementor_menu }}></a></span> */}
                    <span dangerouslySetInnerHTML={{ __html: window.elementor_menu }}></span>
                </div>
                <div class="sec-on">
                    <h4>Traders</h4>
                    <span><a href="">Log in</a></span>
                </div>
            </div>
        </div>
        <div class="footer">
            <a href={props?.site_url}>
                <img src="/wp-content/uploads/2022/10/mastoria-logo.png" title="mastoria-logo" alt="mastoria-logo" /></a>
            <input type="email" placeholder="Join our mailing list"></input>
            <button type="submit">Εγγραφή<i aria-hidden="true" class="fas fa-arrow-right"></i></button>
            <div class="social_icon">
                {/* <h5>Follow Us</h5> */}
                <i aria-hidden="true" class="fab fa-facebook-square"></i>
                <i aria-hidden="true" class="fab fa-twitter-square"></i>
                <i aria-hidden="true" class="fab fa-linkedin"></i>
            </div>
            <p class="copyright">©  2022 Tamastoria.gr - All Rights Reserved</p>
        </div>
    </section>);
}

export default HeaderMobileMenu;